import { IMedia, IMediaBase, IMediaFiles } from './media.type'

export interface IMediaListItem extends IMedia {
  connection: IMediaConnection | null
  size?: number | null
  size_large?: number | null
  size_medium?: number | null
  size_small?: number | null
}

export interface IMediaListRespDto {
  data: IMediaListItem[]
  count: number
}

export type MediaConnectionType =
  | 'account'
  | 'impact'
  | 'journey'
  | 'product'
  | 'scan'
  | 'scan_draft'
  | 'step'

export interface IMediaConnection {
  title: string
  subTitle?: string
  id: string
  image?: string
  image_medium?: string
  image_small?: string
  type: MediaConnectionType
}

export interface ICreateMediaForm {
  media: IMediaFiles
}

export interface ICreateMediaDto {
  media: IMediaBase[]
}

export enum EMediaConnectionType {
  Account = 'account',
  Impact = 'impact',
  Journey = 'journey',
  Product = 'product',
  Step = 'step',
  Scan = 'scan',
  ScanDraft = 'scan_draft',
}

export interface IMediaConnectionItems extends Array<IMediaConnectionItem> {}

export interface IMediaConnectionItem {
  name?: string
  id: string
  image?: string
  image_medium?: string
  image_small?: string
  account_holder?: string
  batch_id?: string
}
